var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 4.16732L9.9987 4.17565M9.9987 10.0007L9.9987 10.009M9.9987 15.834L9.9987 15.8423M9.9987 5.00065C9.53846 5.00065 9.16536 4.62755 9.16536 4.16732C9.16536 3.70708 9.53846 3.33398 9.9987 3.33398C10.4589 3.33398 10.832 3.70708 10.832 4.16732C10.832 4.62755 10.4589 5.00065 9.9987 5.00065ZM9.9987 10.834C9.53846 10.834 9.16536 10.4609 9.16536 10.0007C9.16536 9.54041 9.53846 9.16732 9.9987 9.16732C10.4589 9.16732 10.832 9.54041 10.832 10.0007C10.832 10.4609 10.4589 10.834 9.9987 10.834ZM9.9987 16.6673C9.53846 16.6673 9.16536 16.2942 9.16536 15.834C9.16536 15.3737 9.53846 15.0007 9.9987 15.0007C10.4589 15.0007 10.832 15.3737 10.832 15.834C10.832 16.2942 10.4589 16.6673 9.9987 16.6673Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionMenuIcon);
export default __webpack_public_path__ + "static/media/action-menu-icon.8c07a106359079afb211ccbd0d4dc6fb.svg";
export { ForwardRef as ReactComponent };